/** API error codes (ARCHITECTURE §6). Shape on the wire: `{ error: { code, message, details? } }`. */
export const ERROR_CODES = [
  'unauthenticated',
  'forbidden',
  'not_found',
  'validation_failed',
  'feature_not_in_plan',
  'insufficient_credits',
  'conflict',
  'rate_limited',
  'unsupported_query',
  'subscription_inactive',
  /** A public page that existed but is no longer available (archived form, plan lost). */
  'gone',
  'internal',
] as const;
export type ErrorCode = (typeof ERROR_CODES)[number];

export const ErrorCode = Object.fromEntries(ERROR_CODES.map((c) => [c, c])) as {
  readonly [K in ErrorCode]: K;
};

export const ERROR_HTTP_STATUS: Record<ErrorCode, number> = {
  unauthenticated: 401,
  forbidden: 403,
  not_found: 404,
  validation_failed: 422,
  feature_not_in_plan: 402,
  insufficient_credits: 402,
  conflict: 409,
  rate_limited: 429,
  unsupported_query: 422,
  subscription_inactive: 402,
  gone: 410,
  internal: 500,
};

export interface ApiErrorBody {
  error: { code: ErrorCode; message: string; details?: unknown };
}

export function isApiErrorBody(v: unknown): v is ApiErrorBody {
  return (
    typeof v === 'object' &&
    v !== null &&
    'error' in v &&
    typeof (v as { error: unknown }).error === 'object' &&
    (v as { error: { code?: unknown } }).error !== null &&
    typeof (v as { error: { code?: unknown } }).error.code === 'string'
  );
}
